(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ryu-story"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-ryu-story]');
    if (!sections.length) return;

    sections.forEach(function(section) {
      var chapters = section.querySelectorAll('.ryu-story__chapter');
      if (!chapters.length) return;

      var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-visible', 'true');
            // Once revealed, stop observing to keep it visible permanently
            revealObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.2,
        rootMargin: '0px 0px -10% 0px'
      });

      chapters.forEach(function(chapter) { revealObserver.observe(chapter); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
